import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Activity, HeartPulse, Brain, Utensils } from "lucide-react";

const HIGHLIGHTS = [
  { icon: HeartPulse, label: "Vitals & bloodwork", body: "Blood pressure, resting HR, and a clinician-approved lab panel." },
  { icon: Activity, label: "Fitness & function", body: "Cardio fitness, grip strength, mobility and balance — measured, not guessed." },
  { icon: Utensils, label: "Nutrition & sleep", body: "Structured dietary review, sleep and recovery assessment." },
  { icon: Brain, label: "Personal action plan", body: "A physician-reviewed 3–6 month plan. Not a score you can't act on." },
];

export default function AssessmentPromo() {
  return (
    <section className="relative bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <div className="eyebrow text-[var(--lc-moss)] mb-5">The Longevity Assessment</div>
            <h2 className="font-serif-display text-[clamp(36px,5.5vw,76px)] leading-[1] font-light">
              Where are you today? <span className="italic">What matters most?</span>
            </h2>
            <p className="mt-8 max-w-xl text-[15px] leading-relaxed text-[var(--lc-muted)]">
              A premium baseline assessment that measures your health, capability and
              lifestyle — reviewed by a licensed physician and converted into a
              personalized 3–6 month action plan. Answer 15–25 minutes online, then
              visit us for measurements and lab work.
            </p>
          </div>
          <div className="lg:col-span-5 lg:text-right">
            <Link
              to="/assessment"
              className="group inline-flex items-center gap-3 bg-[var(--lc-ink)] hover:bg-[var(--lc-moss-dark)] text-white px-8 py-4 text-[12px] font-bold tracking-[0.18em] uppercase transition-colors"
            >
              Begin Assessment <ArrowUpRight className="h-4 w-4" />
            </Link>
            <div className="mt-4 flex flex-wrap gap-2 lg:justify-end">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-[var(--lc-line)] rounded-full text-[11px] font-semibold tracking-[0.14em] uppercase" style={{ color: "#3E5A7A" }}>
                Blue Circle · Men
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-[var(--lc-line)] rounded-full text-[11px] font-semibold tracking-[0.14em] uppercase" style={{ color: "#B08585" }}>
                Pink Circle · Women
              </span>
            </div>
          </div>
        </div>

        <div className="mt-14 lg:mt-20 grid sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {HIGHLIGHTS.map((h) => {
            const Icon = h.icon;
            return (
              <div key={h.label} className="border-t border-[var(--lc-ink)] pt-5">
                <Icon className="h-5 w-5 text-[var(--lc-moss)]" />
                <div className="mt-3 font-serif-display text-xl leading-tight">{h.label}</div>
                <p className="mt-2 text-[13px] leading-relaxed text-[var(--lc-muted)]">{h.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
